import { API_BASE_URL } from "../../config/apiConfig";
import { refreshAccessToken } from "./tokenRefresh";

// fetch wrapper that attaches the current bearer token and, if the request
// comes back 401/403 (an expired access token), transparently refreshes the
// token once and retries. Without this, a request that happens to land right as
// the 2h access token expires surfaces a confusing feature-level error ("failed
// to generate exam") when the real problem was just an expired token that the
// refresh token could have fixed silently.
//
// Pass a relative path ("/api/...") or a full URL. Any headers you pass are
// preserved; only Authorization is (re)set from localStorage on each attempt.
export const authFetch = async (path, options = {}) => {
    const url = path.startsWith("http") ? path : `${API_BASE_URL}${path}`;
    const buildOptions = () => ({
        ...options,
        headers: {
            ...(options.headers || {}),
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });

    let res = await fetch(url, buildOptions());
    if (res.status === 401 || res.status === 403) {
        const refreshed = await refreshAccessToken();
        if (refreshed) {
            res = await fetch(url, buildOptions());
        }
    }
    return res;
};
